import { render, staticRenderFns } from "./SamTabs.vue?vue&type=template&id=d1af5894&scoped=true&"
import script from "./SamTabs.vue?vue&type=script&lang=js&"
export * from "./SamTabs.vue?vue&type=script&lang=js&"
import style0 from "./SamTabs.vue?vue&type=style&index=0&id=d1af5894&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1af5894",
  null
  
)

export default component.exports